import { appendPath } from '@truqc/content-path';
import contentPathSelector from './contentPathSelector';
export default (state, props) => {
  const contentPath = contentPathSelector(state, props);
  const {
    parentContentPath = '/'
  } = props;
  if (contentPath) {
    return appendPath(parentContentPath, contentPath);
  }
  return parentContentPath;
};